module.exports = __webpack_public_path__ + "static/media/cloud.ffd207b7.svg";